import { datadogRum } from '@datadog/browser-rum';

export default function trackOpenTextSearchResult(
  query: string,
  hasResults: boolean
) {
  datadogRum.addAction('open text search results', { hasResults, query });
}
